import {WicketAdminUserApiFilter} from '../wicket-admin-audience-filter-data';
import {WicketAdminEmailMessage} from '../wicket-admin-email-message';
import {WicketAdminPublicationStatus} from '../wicket-admin-publication-status';

export interface WicketAdminEmailCampaign {
  id?: string;
  created_at?: string;
  name: string;
  campaign_start?: string;
  message: WicketAdminEmailMessage;
  status: WicketAdminPublicationStatus;
  user_filter: WicketAdminUserApiFilter;
}
